import { Link } from "react-router-dom";
import { APP_NAME } from "./constants";

const faqData = [
  {
    title: `What is ${APP_NAME}?`,
    description: `${APP_NAME} is the premier AI-powered property management platform designed specifically for landlords and property managers to streamline their operations. Unlike traditional property management software, ${APP_NAME} combines rent tracking, tenant communication, repair management, and tenant screening into one comprehensive platform. This technology bridges the gap between manual processes and automated efficiency, resulting in better tenant relationships and higher profitability.\n`,
  },
  {
    title: `Who built ${APP_NAME}?`,
    description: `${APP_NAME} was developed by a team of property managers and AI specialists who understand the challenges of managing rental properties. Our founders experienced firsthand the inefficiencies of manual property management and the need for better tools. This personal journey inspired our mission: to reduce administrative burden, increase rent collection rates, and create more satisfied tenants through streamlined, automated property management.\n`,
  },
  {
    title: `Can ${APP_NAME} help with leases?`,
    description: `${APP_NAME} can help you understand common lease terms and workflows, and provide general guidance for what to consider. We do not generate lease documents or legal documents, and we do not provide legal advice. For documents and legal advice, consult a qualified attorney in your jurisdiction.\n`,
  },
  {
    title: `What types of properties does ${APP_NAME} support?`,
    description: `${APP_NAME} supports all types of rental properties including single-family homes, multi-family units, apartments, condos, commercial properties, and mixed-use buildings. Our platform is designed to scale from individual landlords with one property to large property management companies with hundreds of units.\n`,
  },
  {
    title: `How does ${APP_NAME} improve rent collection?`,
    description: `By automating rent reminders, tracking payments in real-time, and providing clear communication channels, ${APP_NAME} helps landlords collect rent more reliably. The platform typically reduces late payments by 40% and improves overall collection rates by streamlining the payment process and providing better tenant communication.\n`,
  },
  {
    title: `Is ${APP_NAME} suitable for all property sizes?`,
    description: `${APP_NAME} is designed to accommodate landlords of all sizes, from individual property owners to large property management companies. Our platform scales seamlessly, whether you manage one property or hundreds of units. The intuitive interface makes it easy for anyone to get started, regardless of their technical experience.\n`,
  },
  {
    title: `How secure is my property and tenant data on ${APP_NAME}?`,
    description: `Data security is foundational to ${APP_NAME}. We implement bank-level security protocols, end-to-end encryption for all data transfers, and secure cloud storage with regular security audits. Property and tenant information never leaves your secure account environment without explicit consent. We provide clear privacy documentation and never use your data for marketing or third-party purposes.\n`,
  },
  {
    title: `How quickly can I implement ${APP_NAME} in my business?`,
    description: `Most landlords are fully operational with ${APP_NAME} within 10 minutes of signing up. Our streamlined onboarding process includes adding your properties, setting up rent tracking, and configuring your preferences. The intuitive interface requires minimal training. Most users master the basics in less than 30 minutes. We also provide ongoing technical support and regular updates to ensure you're always getting the most from ${APP_NAME}.\n`,
  },
  {
    title: `What ROI can I expect from implementing ${APP_NAME}?`,
    description: `Landlords typically see ROI within the first 1-3 months of implementing ${APP_NAME}. The combination of reduced late payments, fewer missed follow-ups, and less time spent on administrative tasks creates significant financial benefits. Many landlords report saving 20+ hours per month on property management tasks.\n`,
  },
  {
    title: `How can I get started with ${APP_NAME}?`,
    description: (
      <>
        <Link to="/contact">
          <b>Contact us today</b>
        </Link>{" "}
        to schedule a personalized demo of {APP_NAME}. We'll show you exactly
        how the platform works with your specific properties, discuss
        integration with your existing processes, and create a custom
        implementation plan. Most landlords are up and running within 10 minutes
        of their initial setup.
      </>
    ),
  },
];

export default faqData;
